"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringFormat = void 0;
const StringFormatType = {
    string: "%s",
    int: "%d",
    float: "%f",
    "%s": "%s",
    "%d": "%d",
    "%f": "%f",
};
class StringFormat {
    constructor() {
        this.formatters = new Map();
        this.regex = new RegExp(`(${StringFormatType.string}|${StringFormatType.int}|${StringFormatType.float})`, "g");
        const stringFormatter = (t, v) => t.replace(StringFormatType.string, v);
        const intFormatter = (t, v) => t.replace(StringFormatType.int, Math.floor(v).toLocaleString());
        const floatFormatter = (t, v) => t.replace(StringFormatType.float, v.toLocaleString());
        this.formatters.set(StringFormatType.string, stringFormatter);
        this.formatters.set(StringFormatType.int, intFormatter);
        this.formatters.set(StringFormatType.float, floatFormatter);
    }
    format(template, ...params) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!template || !params || params.length === 0) {
            return template;
        }
        let paramIndex = 0;
        template = template.replace(this.regex, (match, _offset, value) => {
            const stringKey = match;
            // eslint-disable-next-line  @typescript-eslint/no-unnecessary-condition
            const formatType = StringFormatType[stringKey] || StringFormatType.string;
            const format = this.formatters.get(formatType);
            if (!format) {
                return value;
            }
            if (paramIndex >= params.length) {
                return value;
            }
            const result = format(formatType, params[paramIndex]);
            paramIndex++;
            return result;
        });
        return template;
    }
}
exports.stringFormat = new StringFormat();
